import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	resultsParent: {
		display       : "flex",
		flexDirection : "column",
		alignItems    : "center",
		padding       : "0 4rem",
		background    : theme.other.colors.background.secondary
	},
	tabsContainer: {
		maxWidth : "1000px",
		width    : "100%"
	}
} ), { name: "results" } );